/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/surveys/survey_stats_summary" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSurveysSurveyStatsSummary } from "./constants";
import type { GetEngagementAppGroupIdSurveysSurveyStatsSummaryResult } from "./types";
import { isGetEngagementAppGroupIdSurveysSurveyStatsSummaryResult } from "./validators";

export const getEngagementAppGroupIdSurveysSurveyStatsSummary = reactQueryFetcherAdapter(
  engagementAppGroupIdSurveysSurveyStatsSummary,
  (signal: AbortSignal, appGroupId: string): Promise<GetEngagementAppGroupIdSurveysSurveyStatsSummaryResult> => {
    return fetch(`/engagement/${appGroupId}/surveys/survey_stats_summary`, "GET", {}, { signal });
  },
  isGetEngagementAppGroupIdSurveysSurveyStatsSummaryResult
);
